// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lowlight {
  opacity: 0.2;
}

.impersonate {
  cursor: pointer;
}

.highlightBuyer, .highlightSeller {
  color: #fff;
  line-height: 34px;
  font-weight: 600;
  border-radius: 5px;
  padding: 0 6px;
  margin-right: 10px;
}

.highlightSeller {
  background-color: #437381;
  line-height: 38px;
}

.highlightBuyer {
  background-color: #734381;
  line-height: 38px;
}

.stats-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  margin-bottom: 10px;
  grid-gap: 10px;
}

.stats-box {
  border-radius: 8px !important;
  background-color: #fff;
}
.stats-box .widget-border {
  border-radius: 8px;
}
.stats-box .stats-inner {
  height: 75px;
  padding: 10px 10px 10px 10px;
  color: var(--textColour);
  text-align: left;
  cursor: pointer;
}
.stats-box .stats-inner .number {
  font-size: 2rem;
  line-height: 2rem;
  text-align: right;
  font-weight: 600;
  color: #0BAF9F;
}
.stats-box .stats-inner .title {
  font-size: 15px;
  line-height: 17px;
  font-weight: 500;
}
.stats-box .stats-inner .subtitle {
  color: #888;
  font-size: 11px;
  margin: 5px 0;
}

.top-section {
  background-color: #fff;
}

.header-box {
  background-color: #fff;
  border-radius: 8px;
  padding: 15px;
}

.overview-icon {
  display: inline-block;
  text-align: center;
  color: #505050;
  font-size: 9px;
  background-color: #efefef;
  line-height: 16px;
  width: 16px;
  border-radius: 8px;
}

.overview-label {
  font-weight: 500;
  font-size: 12px;
  color: #505050;
  line-height: 16px;
  margin-left: 5px;
  margin-right: 5px;
  display: inline-block;
}

.overview-value {
  font-weight: 700;
  font-size: 12px;
  color: #505050;
  display: inline-block;
  max-width: 100%;
  overflow-x: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}

.button-bar button.buy-sell {
  background-color: #169ab8;
  color: #fff;
  font-weight: 500;
}
.button-bar button.buy-sell.lowlight {
  opacity: 0.3;
}

.header-text {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.5px;
}

.sub-header-text {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: -0.5px;
}

.status-text {
  font-size: 0.75rem;
  display: inline-block;
  border-radius: 4px;
  line-height: 32px;
  font-weight: 500;
  padding: 0 6px;
  margin-left: 8px;
}

.sub-text {
  font-size: 0.875rem;
  font-weight: 400;
  color: rgb(50, 50, 50);
}

.ilv {
  white-space: nowrap;
  overflow-x: hidden;
}

.widget-title {
  padding-left: 5px;
  font-weight: 600;
}

.error-value {
  color: var(--dangerColour);
}

.status-colour.status-colour-1 {
  background-color: var(--successColour);
  color: #fff;
}
.status-colour.status-colour-2 {
  background-color: var(--warningColour);
  color: #fff;
}
.status-colour.status-colour-3 {
  background-color: var(--dangerColour);
  color: #fff;
}
.status-colour.status-colour-4 {
  background-color: #734381;
  color: #fff;
  border-color: #734381;
}

.form-control.form-control-narrow {
  padding-top: 0.1rem !important;
  padding-bottom: 0.1rem !important;
  line-height: 16px !important;
  height: 24px !important;
}

.stat-input {
  font-size: 0.75rem;
}
.stat-input .stat-input-value {
  font-weight: 600;
  display: inline-block;
  width: 60px;
  height: 24px;
  font-size: 0.75rem;
}
.stat-input .stat-input-value input {
  font-size: 0.75rem;
  height: 20px !important;
  width: 40px !important;
}

.customer-type {
  cursor: pointer;
}
.customer-type.customer-type-0 .overview-value {
  color: var(--dangerColour);
}
.customer-type.customer-type-0 {
  color: #c00;
  font-weight: bold;
}

.call-ball.call-ball-0 {
  background-color: var(--warningColour);
  color: #fff;
}
.call-ball.call-ball-1 {
  background-color: var(--successColour);
  color: #fff;
}
.call-ball.call-ball-2 {
  background-color: var(--dangerColour);
  color: #fff;
}

.edit-button {
  background-color: #DEDFE8;
  color: rgba(0, 0, 0, 0.5);
  border: 1px solid #bbb;
}

::ng-deep .customer-type-change .mdb-select-value.form-control {
  background-color: #fff !important;
  margin-bottom: 0px;
  padding-bottom: 0px !important;
}

::ng-deep .customer-type-change .mdb-select-wrapper {
  height: 30px !important;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/admin/customer/customer-view/customer-view.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AACF;;AAEA;EACE,yBAAA;EACA,iBAAA;AACF;;AAEA;EACE,yBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,2DAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EAEE,6BAAA;EACA,sBAAA;AAAF;AAEE;EACE,kBAAA;AAAJ;AAME;EAEE,YAAA;EACA,4BAAA;EACA,wBAAA;EACA,gBAAA;EACA,eAAA;AALJ;AAOI;EACE,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AALN;AASI;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAPN;AAUI;EACE,WAAA;EACA,eAAA;EACA,aAAA;AARN;;AAaA;EACE,sBAAA;AAVF;;AAaA;EAEE,sBAAA;EACA,kBAAA;EACA,aAAA;AAXF;;AAcA;EACE,qBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AAXF;;AAcA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AAXF;;AAcA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;AAXF;;AAiBI;EACE,yBAAA;EACA,WAAA;EACA,gBAAA;AAdN;AAgBM;EACE,YAAA;AAdR;;AAoBA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;AAjBF;;AAoBA;EACE,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,gBAAA;EACA,sBAAA;AAjBF;;AAoBA;EACE,mBAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,iBAAA;EACA,gBAAA;AAjBF;;AAoBA;EACE,0BAAA;AAjBF;;AAsBE;EACE,sCAAA;EACA,WAAA;AAnBJ;AAsBE;EACE,sCAAA;EACA,WAAA;AApBJ;AAuBE;EACE,qCAAA;EACA,WAAA;AArBJ;AAwBE;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;AAtBJ;;AA0BA;EAEE,8BAAA;EACA,iCAAA;EACA,4BAAA;EACA,uBAAA;AAxBF;;AA4BA;EAEE,kBAAA;AA1BF;AA4BE;EACE,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AA1BJ;AA4BI;EACE,kBAAA;EACA,uBAAA;EACA,sBAAA;AA1BN;;AA+BA;EAaE,eAAA;AAxCF;AA8BI;EACE,0BAAA;AA5BN;AAgCE;EACE,WAAA;EACA,iBAAA;AA9BJ;;AAsCE;EACE,sCAAA;EACA,WAAA;AAnCJ;AAsCE;EACE,sCAAA;EACA,WAAA;AApCJ;AAuCE;EACE,qCAAA;EACA,WAAA;AArCJ;;AAyCA;EACE,yBAAA;EACA,yBAAA;EACA,sBAAA;AAtCF;;AAyCA;EACE,iCAAA;EACA,kBAAA;EACA,8BAAA;AAtCF;;AAyCA;EACE,uBAAA;AAtCF","sourcesContent":[".lowlight {\n  opacity: 0.2;\n}\n\n.impersonate {\n  cursor: pointer;\n}\n\n.highlightBuyer, .highlightSeller {\n  color: #fff;\n  line-height: 34px;\n  font-weight: 600;\n  border-radius: 5px;\n  padding: 0 6px;\n  margin-right: 10px;\n}\n\n.highlightSeller {\n  background-color: #437381;\n  line-height: 38px;\n}\n\n.highlightBuyer {\n  background-color: #734381;\n  line-height: 38px;\n}\n\n.stats-row {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  margin-bottom: 10px;\n  grid-gap: 10px;\n}\n\n.stats-box {\n\n  border-radius: 8px !important;\n  background-color: #fff;\n\n  .widget-border {\n    border-radius: 8px;\n  }\n\n  .top-line {\n  }\n\n  .stats-inner {\n\n    height: 75px;\n    padding: 10px 10px 10px 10px;\n    color: var(--textColour);\n    text-align: left;\n    cursor: pointer;\n\n    .number {\n      font-size: 2rem;\n      line-height: 2rem;\n      text-align: right;\n      font-weight: 600;\n      color: #0BAF9F;\n\n    }\n\n    .title {\n      font-size: 15px;\n      line-height: 17px;\n      font-weight: 500;\n    }\n\n    .subtitle {\n      color: #888;\n      font-size: 11px;\n      margin: 5px 0;\n    }\n  }\n}\n\n.top-section {\n  background-color: #fff;\n}\n\n.header-box {\n  // background-color: #fff;\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 15px;\n}\n\n.overview-icon {\n  display: inline-block;\n  text-align: center;\n  color: #505050;\n  font-size: 9px;\n  background-color: #efefef;\n  line-height: 16px;\n  width: 16px;\n  border-radius: 8px;\n}\n\n.overview-label {\n  font-weight: 500;\n  font-size: 12px;\n  color: #505050;\n  line-height: 16px;\n  margin-left: 5px;\n  margin-right: 5px;\n  display: inline-block;\n}\n\n.overview-value {\n  font-weight: 700;\n  font-size: 12px;\n  color: #505050;\n  display: inline-block;\n  max-width: 100%;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  vertical-align: bottom;\n}\n\n.button-bar {\n  button {\n\n    &.buy-sell {\n      background-color: #169ab8;\n      color: #fff;\n      font-weight: 500;\n\n      &.lowlight {\n        opacity: 0.3;\n      }\n    }\n  }\n}\n\n.header-text {\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: -0.5px;\n}\n\n.sub-header-text {\n  font-size: 13px;\n  font-weight: 500;\n  letter-spacing: -0.5px;\n}\n\n.status-text {\n  font-size: 0.75rem;\n  display: inline-block;\n  border-radius: 4px;\n  line-height: 32px;\n  font-weight: 500;\n  padding: 0 6px;\n  margin-left: 8px;\n}\n\n.sub-text {\n  font-size: 0.875rem;\n  font-weight: 400;\n  color: rgb(50, 50, 50);\n}\n\n.ilv {\n  white-space: nowrap;\n  overflow-x: hidden;\n}\n\n.widget-title {\n  padding-left: 5px;\n  font-weight: 600;\n}\n\n.error-value {\n  color: var(--dangerColour);\n}\n\n.status-colour {\n\n  &.status-colour-1 {\n    background-color: var(--successColour);\n    color: #fff;\n  }\n\n  &.status-colour-2 {\n    background-color: var(--warningColour);\n    color: #fff;\n  }\n\n  &.status-colour-3 {\n    background-color: var(--dangerColour);\n    color: #fff;\n  }\n\n  &.status-colour-4 {\n    background-color: #734381;\n    color: #fff;\n    border-color: #734381;\n  }\n}\n\n.form-control.form-control-narrow {\n\n  padding-top: 0.1rem !important;\n  padding-bottom: 0.1rem !important;\n  line-height: 16px !important;\n  height: 24px !important;\n\n}\n\n.stat-input {\n\n  font-size: 0.75rem;\n\n  .stat-input-value {\n    font-weight: 600;\n    display: inline-block;\n    width: 60px;\n    height: 24px;\n    font-size: 0.75rem;\n\n    input {\n      font-size: 0.75rem;\n      height: 20px !important;\n      width: 40px !important;\n    }\n  }\n}\n\n.customer-type {\n\n  &.customer-type-0 {\n    .overview-value {\n      color: var(--dangerColour);\n    }\n  }\n\n  &.customer-type-0 {\n    color: #c00;\n    font-weight: bold;\n  }\n\n  cursor: pointer;\n}\n\n.call-ball {\n\n  &.call-ball-0 {\n    background-color: var(--warningColour);\n    color: #fff;\n  }\n\n  &.call-ball-1 {\n    background-color: var(--successColour);\n    color: #fff;\n  }\n\n  &.call-ball-2 {\n    background-color: var(--dangerColour);\n    color: #fff;\n  }\n}\n\n.edit-button {\n  background-color: #DEDFE8;\n  color: rgba(0, 0, 0, 0.5);\n  border: 1px solid #bbb;\n}\n\n::ng-deep .customer-type-change .mdb-select-value.form-control {\n  background-color: #fff !important;\n  margin-bottom: 0px;\n  padding-bottom: 0px !important;\n}\n\n::ng-deep .customer-type-change .mdb-select-wrapper {\n  height: 30px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
